import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ number, eyebrow, title, subtitle, center = true }) {
  return (
    <div className={center ? "text-center" : "text-left"}>
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]" data-testid={`${(title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}-eyebrow`}>
          {number && <span className="text-[#8C6D46] mr-3">{number}</span>}
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-4 text-[#F8F9FA]">{title}</h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.2}>
          <p className="text-slate-400 text-base sm:text-lg mt-4 max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
        </Reveal>
      )}
      <Reveal delay={0.25} className={center ? "flex justify-center" : ""}>
        <div className="gold-line w-32 mt-8" />
      </Reveal>
    </div>
  );
}
